/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.success\":[\"Cirkel med bock\"]}");